import React from 'react'

const style = { marginBottom: '-1px' }

export function Placeholder (props) {
  return (
    <div className='row no-gutters' style={style}>
      <div className='col-12'>
        <div className='return-tile__loading'>
          <div className='return-tile__loading--text' />
          <div className='return-tile__loading--text' />
          <div className='return-tile__loading--text' />
        </div>
      </div>
    </div>
  )
}
